import { faPlusCircle } from "@fortawesome/pro-regular-svg-icons";

import { PatientKind } from "common/types";
import Image from "common/components/Image";
import Icon from "common/components/Icon";

import SelectButton from "client/common/components/buttons/SelectButton";

import { imageForSpecies } from "../utils";
import { useAccountCreatePetDrawer } from "../stackables";

import styles from "../styles/PatientMultiSelectPanel.module.less";

export type PatientForMultiSelectPanel = {
  id: number;
  name_display: string;
  species: PatientKind;
  species_display: string;
};

type PatientMultiSelectPanelProps = {
  values: PatientForMultiSelectPanel[];
  onChange: (values: PatientForMultiSelectPanel[]) => void;
  options: PatientForMultiSelectPanel[];
};

const PatientMultiSelectPanel = ({ values, onChange, options }: PatientMultiSelectPanelProps) => {
  const { open: openCreatePet } = useAccountCreatePetDrawer();

  const selectedIds = new Set(values.map((value) => value.id));

  const handleClick = (clicked: PatientForMultiSelectPanel) => {
    const selectedWithoutClicked = options.filter(
      (o) => o.id !== clicked.id && selectedIds.has(o.id),
    );
    if (selectedIds.has(clicked.id)) {
      onChange(selectedWithoutClicked);
    } else {
      onChange([...selectedWithoutClicked, clicked]);
    }
  };

  return (
    <div className={styles.container}>
      {options.map((option) => (
        <SelectButton
          align="center"
          key={option.id}
          isActive={selectedIds.has(option.id)}
          onClick={() => handleClick(option)}
          renderContent={({ isActive }) => (
            <div className={styles.content}>
              <span className={styles.petName}>{option.name_display}</span>
              <Image src={imageForSpecies(option.species, isActive)} alt={option.species_display} />
            </div>
          )}
        />
      ))}
      <SelectButton
        align="center"
        onClick={() => openCreatePet({})}
        isActive={false}
        disabled={false}
        renderContent={() => (
          <div className={styles.addPet}>
            Add new pet
            <Icon icon={faPlusCircle} />
          </div>
        )}
      />
    </div>
  );
};

export default PatientMultiSelectPanel;
